var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildInitialState } from '../store/initial-state';
import { buildStoreAudiencesFromApiCampaign } from './audiences';
import { buildStoreTimelineFromApiCampaign } from './timeline';
import { buildStoreContentFromApiCampaign } from './content';
import { buildStorePromoIdFromApiCampaign } from './promo-id';
import { buildStoreDeliveryChannelsFromApiCampaign } from './delivery-channels';
import { buildStoreImagesFromApiCampaign } from './images';
export var buildCampaignStateFromApiData = function (_a) {
    var campaign = _a.campaign, session = _a.session;
    var initialState = buildInitialState({ session: session });
    var mapperParams = { campaign: campaign, session: session };
    var nextState = __assign(__assign({}, initialState), { id: campaign.id, editableFields: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, initialState.editableFields), { type: { value: campaign.type }, displayName: { value: campaign.displayName } }), buildStorePromoIdFromApiCampaign(mapperParams)), buildStoreDeliveryChannelsFromApiCampaign(mapperParams)), buildStoreImagesFromApiCampaign(mapperParams)), buildStoreAudiencesFromApiCampaign(mapperParams)), buildStoreTimelineFromApiCampaign(mapperParams)), buildStoreContentFromApiCampaign(mapperParams)) });
    return nextState;
};
